import React from 'react';

const CurrentContextIdContext = React.createContext<string>('');
export default CurrentContextIdContext;
